// language=GraphQL
export const ALL_ESIM_CONFIGS_QUERY = `query Query($withRegions: Boolean = false) {
  esimConfigs: ratioEsimConfigs {
    id
    enabled
    regions @include(if: $withRegions) {
      id
      name
      serviceCodePrefix
    }
  }
}`

// language=GraphQL
export const SINGLE_ESIM_CONFIG_QUERY = `query Query($id: ID!, $withRegions: Boolean = false) {
  esimConfig: ratioEsimConfig(id: $id) {
    id
    enabled
    regions @include(if: $withRegions) {
      id
      name
      serviceCodePrefix
    }
  }
}`

// language=GraphQL
export const CREATE_ESIM_CONFIG_MUTATION = `
  mutation Mutation($input: CreateRatioEsimConfigInput, $withRegions: Boolean = false) {
    esimConfig: createRatioEsimConfig(input: $input) {
      id
      enabled
      regions @include(if: $withRegions) {
        id
        name
        serviceCodePrefix
      }
    }
  }`

// language=GraphQL
export const UPDATE_ESIM_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateRatioEsimConfigInput, $withRegions: Boolean = false) {
    esimConfig: updateRatioEsimConfig(input: $input) {
      id
      enabled
      regions @include(if: $withRegions) {
        id
        name
        serviceCodePrefix
      }
    }
  }`

// language=GraphQL
export const DELETE_ESIM_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteRatioEsimConfigInput) {
    deleteRatioEsimConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ESIM_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteRatioEsimConfigInput) {
    forceDeleteRatioEsimConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ESIM_CONFIG_REGIONS_MUTATION = `
  mutation Mutation($input: addRatioEsimConfigRegionsInput) {
    addRatioEsimConfigRegions(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const REMOVE_ESIM_CONFIG_REGIONS_MUTATION = `
  mutation Mutation($input: removeRatioEsimConfigRegionsInput) {
    removeRatioEsimConfigRegions(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const CREATE_ESIM_CONFIG_REGIONS_MUTATION = `
  mutation Mutation($input: createRatioEsimConfigRegionsInput) {
    createRatioEsimConfigRegions(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const DELETE_ESIM_CONFIG_REGIONS_MUTATION = `
  mutation Mutation($input: deleteRatioEsimConfigRegionsInput) {
    deleteRatioEsimConfigRegions(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const UPDATE_ESIM_CONFIG_REGIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioEsimConfigRegionsOrderInput) {
    updateRatioEsimConfigRegionsOrder(input: $input) {
      id
      regionIds
    }
  }`

// language=GraphQL
export const ESIM_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioConfigs: Boolean = false) {
  groupedDependents: ratioEsimConfigDependents(id: $id) {
    ratioConfigs @include(if: $withRatioConfigs) {
      id
    }
  }
}`
